import React, {FC, ReactNode} from 'react';

import {Badge, Colors, Text, Title} from '@optimaxdev/design-system';
import {Icon, Lightning} from '@optimaxdev/icons';
import classNames from 'classnames';

import {CL_RX_METHOD} from 'constants/success';

import s from './selectRxMethodButton.scss';
type PropsType = {
    title: ReactNode;
    description?: ReactNode;
    name: string;
    onClick: () => void;
    badge?: string;
    image?: any;
    isLinkButton?: boolean;
};
/**
 * Popup button for choosing Rx method for CL
 */
export const SelectRxMethodButton: FC<PropsType> = ({
    badge,
    description,
    image,
    isLinkButton,
    name,
    onClick,
    title,
}) => {
    const isDesktop = __BUILD_TYPE__ === 'desktop';
    if (isLinkButton)
        return (
            <button className={s.linkButton} onClick={onClick} type="button">
                <Text color={Colors.limedSpruce} size="14px" textAlign="center" underline>
                    {title}
                </Text>
            </button>
        );
    return (
        <button
            className={classNames(s.button, {[s.desktop]: isDesktop})}
            key={name}
            name={name}
            onClick={onClick}
            type="button"
        >
            <div className={s.imgWrapper}>
                <Icon
                    className={classNames(s.icon, {[s.stroke]: name === CL_RX_METHOD.EYE_EXAM})}
                    height={36}
                    icon={image}
                />
            </div>
            <div className={s.content}>
                <Title
                    color={Colors.black}
                    fontSize="16px"
                    letterSpacing="normal"
                    lineHeight="22px"
                    margin="0 0 4px 0"
                    textAlign="left"
                >
                    {title}
                </Title>
                <Text
                    as="p"
                    color={Colors.limedSpruce}
                    lineHeight="22px"
                    size="16px"
                    textAlign="left"
                >
                    {description}
                </Text>
                {badge && (
                    <Badge className={s.badge} size="medium" type="eco" withIcon>
                        <Icon
                            className={s.badgeIcon}
                            height={12}
                            icon={Lightning}
                            role="presentation"
                            width={9}
                        />
                        {badge}
                    </Badge>
                )}
            </div>
        </button>
    );
};
